/**
 * MissionTimeline - Visual timeline of trajets (planned vs actual)
 */
import React from 'react';
import { MapPin, CheckCircle, Clock, ArrowRight } from 'lucide-react';

export default function MissionTimeline({ trajets = [] }) {
  if (trajets.length === 0) {
    return (
      <div className="text-center py-4 text-gray-400 text-sm">
        Aucun trajet planifié
      </div>
    );
  }

  return (
    <div className="relative">
      {trajets.map((trajet, idx) => {
        const isLast = idx === trajets.length - 1;
        const isActive = trajet.status === 'in_progress';
        const isComplete = trajet.status === 'completed';

        return (
          <div key={trajet.id} className="flex gap-3 mb-0">
            {/* Timeline connector */}
            <div className="flex flex-col items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                isComplete ? 'bg-green-600' :
                isActive ? 'bg-blue-600 animate-pulse' :
                'bg-gray-300'
              }`}>
                {isComplete ? (
                  <CheckCircle className="h-4 w-4 text-white" />
                ) : (
                  <span className="text-xs font-bold text-white">{trajet.sequence_order}</span>
                )}
              </div>
              {!isLast && (
                <div className={`w-0.5 h-12 ${isComplete ? 'bg-green-300' : 'bg-gray-200'}`} />
              )}
            </div>

            {/* Content */}
            <div className={`flex-1 pb-4 ${isLast ? '' : ''}`}>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900">{trajet.from_label || 'Point ' + trajet.sequence_order}</span>
                <ArrowRight className="h-3 w-3 text-gray-400" />
                <span className="text-sm font-medium text-gray-900">{trajet.to_label || 'Point ' + (trajet.sequence_order + 1)}</span>
              </div>
              <div className="flex items-center gap-3 mt-1 text-xs text-gray-500">
                {trajet.distance_planned_km && (
                  <span>{trajet.distance_planned_km} km</span>
                )}
                {trajet.purpose && (
                  <span>{trajet.purpose}</span>
                )}
                {isActive && (
                  <span className="text-blue-600 font-medium">En cours...</span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
